import { atom } from "recoil";

const infoPorduct = atom({
  key: "infoPorduct", // unique ID (with respect to other atoms/selectors)
  default: " ", // default value (aka initial value)
});

export default infoPorduct;
